import { useMutation, useQueryClient } from '@tanstack/react-query';

import { businessRelationshipKeys } from '@/entities/business-relationship/hooks/useBusinessRelationships';
import { performanceKeys } from '@/entities/performance/hooks/usePerformanceQueries';
import { prescriptionApi } from '@/entities/prescription/api/prescription.api';

/**
 * 처방 등록 · 삭제 뒤 함께 새로 고칠 쿼리 — 등록(M-06)과 삭제(M-16 썸네일 ✕)가 같이 쓴다.
 * - 거래처 목록 · 상세 · 연도별 등록 현황 (M-04 · M-07)
 * - 실적 전체: 월 요약 · 병의원 목록 · 처방 이미지(M-16) · 연간 카드 상태
 */
export const useInvalidatePrescriptionQueries = () => {
  const queryClient = useQueryClient();
  return () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: businessRelationshipKeys.all }),
      queryClient.invalidateQueries({ queryKey: performanceKeys.all }),
    ]);
};

export const useDeletePrescriptionImage = () => {
  const invalidate = useInvalidatePrescriptionQueries();
  return useMutation({
    mutationFn: prescriptionApi.deleteImage,
    // 삭제는 멱등이 아니므로(두 번째는 404) 자동 재시도하지 않는다
    retry: 0,
    onSuccess: () => invalidate(),
  });
};

/** 업로드 1 · 3단계. 중복 등록을 막기 위해 자동 재시도하지 않는다 */
export const usePresignedUrls = () =>
  useMutation({ mutationFn: prescriptionApi.presignedUrls, retry: 0 });

export const useUploadComplete = () =>
  useMutation({ mutationFn: prescriptionApi.uploadComplete, retry: 0 });
